import React, { Fragment, useState, useEffect } from 'react';
import IconButton from '@material-ui/core/IconButton';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Button } from 'reactstrap'
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faCheck } from "@fortawesome/free-solid-svg-icons";
import ModalConsentUpdate from './ModalConsentUpdate';

const ListConsentActions = ({ data, state }) => {
    const history = useHistory();
    //const feasibility = data.original.feasibility;
    const [openModal, setOpenModal] = React.useState(false);

    useEffect(() => {

    }, []);

    const inhabilitar = () => {
        let dataCriterial = new FormData();
        dataCriterial.append("id_consentimiento", data.original.id_consentimiento);
        fetch(`${process.env.REACT_APP_PUBLIC_URL}consentimiento-informado/inhabilitar`, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataCriterial
        }).then(response => response.json()).then(data => {
            refresh();
        }).catch(error => console.log("Error"));
    }

    const habilitar = () => {
        let dataCriterial = new FormData();
        dataCriterial.append("id_consentimiento", data.original.id_consentimiento);
        fetch(`${process.env.REACT_APP_PUBLIC_URL}consentimiento-informado/habilitar`, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataCriterial
        }).then(response => response.json()).then(data => {
            refresh();
        }).catch(error => console.log("Error"));
    }

    const openUpdateModal = () => {
        setOpenModal(true);
    }

    const refresh = () => {
        let _url = "/clinical-studio/informed-consent";
        if (window.location.pathname === process.env.PUBLIC_URL + _url) {
            history.replace(process.env.PUBLIC_URL+"/");
            setTimeout(() => {
                history.push({
                    pathname: process.env.PUBLIC_URL + _url,
                    state: data.original.feasibility
                });
            }, 0);
        }
    }

    return (<Fragment>
        <td role="cell">
            <IconButton style={{ fontSize: '15px' }} onClick={() => openUpdateModal()}>
                <FontAwesomeIcon icon={faEdit} />
            </IconButton>

            {
                data.original.estado == 1 ? 
                <IconButton className="text-danger" style={{ fontSize: '15px' }} onClick={() => inhabilitar()}>
                    <FontAwesomeIcon icon={faCheck} />
                </IconButton>
                :
                <IconButton className="text-success" style={{ fontSize: '15px' }} onClick={() => habilitar()}>
                    <FontAwesomeIcon icon={faCheck} />
                </IconButton>
            }


            

            <ModalConsentUpdate
                consent={data.original}
                doCloseModalConsent={() => setOpenModal(false)}
                opened={openModal}
                feasibility={data.original.feasibility}
            />

        </td>
    </Fragment>)
}

export default reduxForm({
    form: `modal-form`, // a unique identifier for this form
})(withTranslation('common')(ListConsentActions));